import React, {Component} from "react"
import PropTypes from "prop-types"
import {FormattedMessage} from "@irati/utils/lang"
import HR from "@irati/ui/src/Layout/Hr"
import Toggle from "@irati/ui/src/FormItem/Toggle"
import Flex from "@irati/ui/src/Flex"
import adminTracking from "@irati-tracking/admin"

import ToggleWrapper from "../../PerksSettings/PerkVisibility/styled/ToggleWrapper"
import Tag from "./styled"

export default class CategoryListItem extends Component {
  static propTypes = {
    category: PropTypes.object.isRequired,
    blacklisted: PropTypes.bool,
    handleToggle: PropTypes.func.isRequired
  }

  static defaultProps = {
    blacklisted: false
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleToggle = () => {
    const {handleToggle, category, blacklisted} = this.props
    adminTracking.changeWellbeingCategoryVisibility(category.id, category.name, blacklisted ? "show" : "hidden")

    const load = handleToggle(category).then(() => {
      this.setState({load: null})
    })
    this.setState({load})
  }

  render() {
    const {category, blacklisted} = this.props
    const {load} = this.state

    return (
      <>
        <Flex justifyContent="space-between" alignItems="center">
          <Flex alignItems="center" height="100%">
            <Tag name={category.name} selected={blacklisted} onClick={this.handleToggle} />
          </Flex>
          <ToggleWrapper>
            <Toggle load={load} checked={!blacklisted} icons={false} onClick={this.handleToggle} />
          </ToggleWrapper>
        </Flex>
        {blacklisted && (
          <p>
            <FormattedMessage id="admin.components.perksVisibility.tagListTag.hiddenCategory.text" />
          </p>
        )}
        <HR />
      </>
    )
  }
}
